import React from 'react'
import { Link } from 'gatsby'
import start1 from '../../assets/images/project-start1.png'
import shape3 from '../../assets/images/shape/vector-shape3.png'
import {useTranslation} from "gatsby-plugin-react-i18next";

const BPe = () => {
    const {t} = useTranslation();

    return (
        <section className="project-start-area ptb-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="project-start-image">
                            <img src={start1} alt="banner" />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="project-start-content">
                            <h2>{t('home.PBeh2')}</h2>
                            <p>{t('home.PBep')}</p>

                            <div className="btn-box">
                                <Link
                                    to="https://admin.crowlr.com/register"
                                    className="default-btn"
                                >
                                    <i className="flaticon-right"></i>
                                    {t("Créeruncomptegratuit")}
                                    <span></span>
                                </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="circle-shape1">
                <img src={shape3} alt="banner" />
            </div>
        </section>
    )
}

export default BPe